<template>
    <va-create-layout>
        <PayWithAmazonEventFee-form
            :title="title"
            :item="item"
        ></PayWithAmazonEventFee-form>
    </va-create-layout>
</template>

<script>
export default {
    props: ["title", "item"],
};
</script>
